type BridgeContent = {
	readonly id?: string | null;
	readonly status?: string | null;
	readonly subType?: string | null;
	readonly type?: string | null;
	readonly title?: string | null;
	readonly version?: { readonly number?: number | null } | null;
	readonly space?: {
		readonly id?: string | null;
		readonly key?: string | null;
		readonly name?: string | null;
		readonly type?: string | null;
	} | null;
	readonly operations?: ReadonlyArray<{
		readonly operation?: string | null;
		readonly targetType?: string | null;
	} | null> | null;
};

/** Only current, complete destination content can replace the legacy bridge's content selection. */
export function isReusableLegacyBridgeContent(
	content: BridgeContent | null | undefined,
	contentId: string,
): content is BridgeContent {
	return Boolean(
		content?.id === contentId &&
		content.status === 'current' &&
		content.subType !== 'live' &&
		content.type &&
		content.title &&
		content.version?.number != null &&
		content.space?.id &&
		content.space.key &&
		content.space.name &&
		content.space.type &&
		content.operations?.every((operation) => operation?.operation && operation.targetType),
	);
}
